export default "__VITE_ASSET__Dnv19LrH__"